import axios from "axios";
import { debounce } from "lodash";
import React, { Component } from "react";
import { PersistantReactTable } from "../components/grid/PersistantReactTable";
import { api } from "../util/api";
import { encodeTableState } from "../util/table";
import { COLUMNS } from "./columns";

// This is where we instantiate the table called by init_billing_rates_grids
// which has been set to locate a div with the id billing_rates to render the grid
export class BillingRatesGrid extends Component {
  //instatiating the table state
  state = {
    data: [],
    pages: -1,
    loading: false,
    search: "",
  };

  constructor(props) {
    super(props);
    // retrieves the underlying dom object, which I believe is defined by the data url specified in the init
    this.table = React.createRef();
    //lodash.debounce delays the invocation of the fetch function, to make the page appear more responsive
    this.fetchData = debounce(this.fetchData, 300);
  }

  updateTableData = () => this.table.updateTableData();

  // not quite sure what this does yet, potentially puts the table state in something reasonable for react
  encodeTableState = (state) => {
    const baseTableState = encodeTableState(state, this.state);

    const tableState = {
      ...baseTableState,
    };

    return tableState;
  };

  // encodes the table state on fetch, then fetches the data
  onFetchData = async (rawTableState, _instance) => {
    const tableState = this.encodeTableState(rawTableState);

    try {
      await this.fetchData(tableState);
    } catch (e) {
      console.error(e);
    }
  };

  // Sets table state to loading, and then attempts to fetch the data based
  // on the data url defined in the initBillingRatesGrid
  fetchData = async (tableState) => {
    // show the loading overlay
    this.setState({ loading: true });

    try {
      let dataReq = await api.get(this.props.dataUrl, {
        params: tableState,
      });

      this.setState({
        data: dataReq.data.rows,
        pages: dataReq.data.pages,
      });
    } catch (e) {
      if (!axios.isCancel(e)) {
        console.error(e);
      }
    } finally {
      this.setState({ loading: false, tableState });
    }
  };

  // on search change, we set the state, to searching and update the table data
  onSearchChange = (e) => {
    const search = e.target.value;
    this.setState({ search }, () => this.updateTableData());
  };

  render() {
    const { data, pages, loading, search } = this.state;

    return (
      <PersistantReactTable
        title="Billing Rates"
        ref={(i) => (this.table = i)}
        columns={COLUMNS}
        data={data}
        pages={pages}
        loading={loading}
        getTrProps={this.rowProps}
        onFetchData={this.onFetchData}
        onSearch={this.onSearchChange}
        search={search}
      />
    );
  }
}
